<template>
    <v-container fluid class="body-wrapper">
        <v-layout wrap>
            <v-flex xs12>
                <content-placeholder v-if="loading"></content-placeholder>
                <v-fade-transition>
                    <div v-show="!loading">

                        <div v-if="notFound" class="text-center mt-4">
                            <content-not-found></content-not-found>
                        </div>

                        <div v-else>
                            <service-provider-profile v-if="provider" class="pt-3" :provider="provider" />

                        </div>
                    </div>
                </v-fade-transition>
            </v-flex>
        </v-layout>
        <quotation-request-form
                v-if="provider && provider.settings.allow_public_quotation"
                :show="showQuotationForm"
                v-on:change="onQuotationDialogChange"
                :service-provider-id="provider.id"
        >
        </quotation-request-form>
        <rating-form
                v-if="canRate"
                v-on:success="getProfile(true)"
                ref="ratingForm"
                :provider="provider"
                :service-options="provider.unrated_services"></rating-form>
    </v-container>
</template>
<script>

    import ContentNotFound from '@/components/common/ContentNotFound'
    import {ApiUtils} from '@/utils/ApiUtils'

    import ContentPlaceholder from '@/components/providers/ContentPlaceholder'
    import QuotationRequestForm from '@/components/providers/QuotationRequestForm'
    import RatingForm from '@/components/ratings/RatingForm'


    import {mapState, mapMutations} from 'vuex'
    import ServiceProviderProfile from "@/components/providers/profile/ServiceProviderProfile";

    const NOT_AVAILABLE = 'n/a'

    export default{
        components: {
          ServiceProviderProfile,
            ContentNotFound,
            ContentPlaceholder,
            QuotationRequestForm,
            RatingForm
        },
        mounted(){
            var vm = this
            setTimeout(function () {
                vm.getProfile()
            }, 100)
        },
        data(){
            return {
                isBGDark: false,
                provider: null,
                loading: true,
                notFound: false,
                showQuotationForm: false,
                breadcrumbs: [
                    {
                        text: 'Servicios',
                        disabled: false,
                        to: '/specialists'
                    },
                    this.providerBreadcrumb || {
                        text: 'Especialista',
                        disabled: true,
                        to: null
                    }
                ]
            }
        },
        computed: {
                ...mapState(['currentUser']),

            settings(){
              const vm = this
              return vm.provider && vm.provider.settings || null
            },
            isInstitution(){
              const vm = this
              return Boolean(vm.provider && vm.provider.institution)
            },
            canRate(){
                return this.currentUser && this.provider && this.provider.unrated_services.length > 0
            },
            providerName(){
                var vm = this
                return (vm.provider.institution ? vm.provider.institution.name : `${vm.provider.user.first_name} ${vm.provider.user.last_name}.`) || ''
            },
            description(){
                var vm = this
                const description = vm.provider.description || '(Sin descripción)'
                return description
            },
            providerBreadcrumb(){

                if (!this.provider) return null

                var provider = this.provider.institution || this.provider.user
                var providerName = provider.name || `${provider.first_name} ${provider.last_names[0]}.`

                return {
                    text: providerName,
                    disabled: true,
                    to: null
                }

            },

        },
        methods: {
            ...mapMutations(['showSnackBar']),

            rate(){
                var vm = this
                vm.$refs.ratingForm.showDialog()
            },

            onQuotationDialogChange(val){
              this.showQuotationForm = val
            },

            async getProfile(silent = false){
                var vm = this
                vm.notFound = false
                var id = vm.$route.params.id
                vm.loading = !silent
                const response = await ApiUtils.makeGet(`public/provider/${id}`, {
                    with_special_sales: true,
                    with_services: true,
                    with_insurance_companies: true
                })
                vm.loading = false

                if (!response.ok) {
                    if (response.status != 404) {
                        vm.showSnackBar('Ha ocurrido un error consultando proveedor')
                    } else {
                        vm.notFound = true
                        vm.provider = null
                    }
                    return
                }

                const json = await response.json()
                const provider = json.result.provider
                vm.provider = provider

            }
        },
        watch:{
            currentUser(newVal, oldVal){
                if(!oldVal && newVal) this.getProfile(true)
            }
        }
    }
</script>

<style scoped>

    >>>a, >>>a:visited {
        color: inherit;
        text-decoration: none;
    }

    .content-wrapper {
        margin-top: 10px;
    }
</style>
